import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { MainNavToggleService } from "../main-nav/services/main-nav-toggle.service";
import { UserNavbarComponent } from "./components/user-navbar/user-navbar.component";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [RouterOutlet, FormsModule, CommonModule, FaIconComponent, UserNavbarComponent],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class HeaderComponent  {

  constructor(
    private mainNavToggleService: MainNavToggleService,
  ) {}


  toggleMainNav() {
    this.mainNavToggleService.toggleMainNav();
  }
}
